export default {
  GET_OFFER_MEAL: 'GET_OFFER_MEAL',
  GET_SOLD_OUT: 'GET_SOLD_OUT',
  GET_UPDATED_OFFER_MEAL_ID: 'GET_UPDATED_OFFER_MEAL_ID',
  GET_VISIBLE: 'GET_VISIBLE',
  GET_PRICE_FORMATTED: 'GET_PRICE_FORMATTED',
  GET_PACKAGING_PRICE_FORMATTED: 'GET_PACKAGING_PRICE_FORMATTED',
  GET_VALID: 'GET_VALID',
  GET_ERRORS: 'GET_ERRORS',
}
